import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ExternalLinkFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.88 11.64H18.24V5.72H12.32V4.08H19.88V11.64ZM4.12 19.84V7.48H15.24L11.54 11.24L12.8 12.5L16.48 8.76V19.84H4.12Z" />
    </SvgIcon>
  );
});
